module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Share-d2f434bb0cd7c447a5cad9b152005031.svg";